import React from 'react';
import { useTranslation, Trans } from 'react-i18next';

import logoWide from '../assets/simcase_wide.png'; // relative path to image
import logoKellogg from '../assets/Kellogg_H_RGB.png'; // relative path to image

const About = ({ onClose = null }) => {
  const { t } = useTranslation();
  return (
    <div className='mt-4 mb-4'>
      <div style={{ padding: '0 10%' }}>
        <h4 className='mt-0'>About</h4>
        <p className='mt-5'>
          Written by
          <br />
          Professor Megan Kashner
        </p>
        <img src={logoKellogg} className='img-fluid' alt='Kellogg' />
        <p className='mt-5'>Produced by SimCase</p>
        <img
          src={logoWide}
          className='img-fluid'
          style={{ maxHeight: '50px' }}
          alt='SimCase'
        />
        <div
          className='text-center p-3 mt-4 mb-2 text-muted'
          style={{ fontSize: '0.9em' }}>
          © 2019 - {new Date().getFullYear()}, SimCase Co. All rights reserved.
        </div>
        <p className='mt-5 mb-0'>
          <span className='btn btn-outline-primary' onClick={onClose}>
            Close
          </span>
        </p>
      </div>
    </div>
  );
};

export default About;
